const formatLastMessage = lastMessage => {
  let lastMessageMsg = lastMessage.message;
  let lastMessageData;
  if (lastMessage.data !== '') {
    try {
      lastMessageData = JSON.parse(lastMessage.data);
    } catch (e) {
      lastMessageData = { listing: { category: '', id: '' } };
    }

    if (lastMessage.customType === 'listing') {
      const { id: listingId, category } = lastMessageData.listing;
      lastMessageMsg = `Interested in ${category} ID ${listingId}`;
    }
  }

  return lastMessageMsg;
};

export default formatLastMessage;
